module.exports = __webpack_public_path__ + "media/images/icon__search--rb-gray-53fbb8daad1a7c863d5bc738f17e6f4d.png";